
/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import React from "react";
import { Container } from "react-bootstrap";
import { QueryListProvider } from "../../../component/solution/QueryList/QueryListContext";
import { QueryList } from "../../../component/solution/QueryList/QueryList";
import { CastType } from "../../../component/solution/Interfaces";

export const Customers: React.FC = () => {

    return(
        <React.Fragment>
            <Container fluid className="p-0">

                <QueryListProvider>
                    <QueryList
                        listTitle={"Customer Master"}
                        recordTitle={"Customer Master"}
                        tableName={"sa_customer"}
                        editTableName={"sa_customer"}
                        editHasCompoundKey={false}
                        join={[]} 
                        select={[
                            {
                                fullColumnName: "contact_code",
                                aggregate: ""
                            }, 
                            {
                                fullColumnName: "fixably_id",
                                aggregate: ""
                            }, 
                            {
                                fullColumnName: "contact_name",
                                aggregate: ""
                            }
                            ,                            
                            {
                                fullColumnName: "erp_updated",
                                aggregate: ""
                            },                            
                            {
                                fullColumnName: "fixably_updated",
                                aggregate: ""
                            },                            
                            {
                                fullColumnName: "created",
                                aggregate: ""
                            },                            
                            {
                                fullColumnName: "updated",
                                aggregate: ""
                            }
                        ]}
                        where={[
                            // {
                            //     fullColumnName: "is_base_item",
                            //     value: false,
                            //     operator: "EQ",
                            //     cast: CastType.BOOLEAN
                            // }
                        ]} 
                        orderBy={[    
                            {
                            fullColumnName: "created",
                            direction: "DESC",
                            cast: CastType.STRING
                        }
                    ]} 
                        groupBy={[]}                   
                    />
                </QueryListProvider>

            </Container>
        </React.Fragment>
    );
}